// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMessageSquarePlus as RawLucideMessageSquarePlus } from "lucide-react";
export const LucideMessageSquarePlus = /* @__PURE__ */ createIcon(RawLucideMessageSquarePlus, "LucideMessageSquarePlus", 2);
